import s from './membership.Style';
import { styled } from 'styled-components';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { isLogin } from '../../../utils/auth';

const Free = () => {
  return (
    <s.Container>
      <s.Div>
        <s.Top>
          <s.Title>Free</s.Title>
          <s.Comment>
            가입만 하면 누구나 이용 가능
            <br />
            땅집고옥션 회원이 되어 경공매 전략을 세워보세요
          </s.Comment>
        </s.Top>
        <s.Row style={{ fontSize: '28px' }}>무료</s.Row>
      </s.Div>
      <s.BenefitList>
        <s.Benefit>
          <img
            src="/assets/images/check/gray_check_20.svg"
            style={{
              width: '24px',
              height: '24px',
            }}
          />
          <span>가입 후 경공매검색 1일 무료</span>
        </s.Benefit>
        <s.Benefit>
          <img
            src="/assets/images/check/gray_check_20.svg"
            style={{
              width: '24px',
              height: '24px',
            }}
          />
          <span>퀀트 상세 정보 맛보기 2건</span>
        </s.Benefit>
        <s.Benefit>
          <img
            src="/assets/images/check/gray_check_20.svg"
            style={{
              width: '24px',
              height: '24px',
            }}
          />
          <span>광역시/도 낙찰통계 제공</span>
        </s.Benefit>
        <s.Benefit>
          <img
            src="/assets/images/check/gray_check_20.svg"
            style={{
              width: '24px',
              height: '24px',
            }}
          />
          <span>하이라이트 경매 기사</span>
        </s.Benefit>
      </s.BenefitList>
    </s.Container>
  );
};

export default Free;
